// extracted by css-extract-rspack-plugin
export default {"codeBlock":"ArJmw","highlight":"lwXfW"};